import React from "react";

const CallToAction = () => {
  return (
    <div className="cta">
      <a href="#contact" className="btn btn-primary">
        Let's Talk
      </a>
      <a href="https://blog.osamaahmed.me" className="btn btn-primary">
        My Blog
      </a>
    </div>
  );
};

export default CallToAction;
